import Environment from './Environment';
import BaseApi from './BaseApi';

class DeviceApi extends BaseApi {
  constructor() {
    super();
    this.url = Environment.videoApi;
    this.path = 'v1/device';
  }
}

export default new DeviceApi();



// WEBPACK FOOTER //
// ./src/api/DeviceApi.js